import type { PollTriggerResponse } from '@/types/api';
import { apiFetch } from './client';

export function triggerPoll(): Promise<PollTriggerResponse> {
  return apiFetch<PollTriggerResponse>('/poll/trigger', { method: 'POST' });
}
